export default {"src":"/fly/_next/static/media/flight.7c1fc608.svg","height":20,"width":21,"blurWidth":0,"blurHeight":0};